// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    FileDown,
    FileExclamationPoint,
    FileHeadphone,
    FileHeart,
    FileImage,
    FileInput,
    FileKey,
    FileLock,
    FileMinus,
    FileMinusCorner,
    FileMusic,
    FileOutput,
    FilePen,
    FilePenLine,
    FilePlay,
    FilePlus,
    FilePlusCorner,
    FileQuestionMark,
    FileScan,
    FileSearch,
    FileSearchCorner,
    FileSignal,
    FileSliders,
    FileSpreadsheet,
    FileStack,
    FileSymlink,
    FileTerminal,
    FileText,
    FileType,
    FileTypeCorner,
    FileUp,
    FileUser,
    FileVideoCamera,
    FileVolume,
    FileX,
    FileXCorner,
    Files,
    Film,
    FingerprintPattern,
    FireExtinguisher,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "file-down" through "fire-extinguisher", inclusive. */
const shard: Record<string, LucideIcon> = {
    "file-down": FileDown,
    "file-exclamation-point": FileExclamationPoint,
    "file-headphone": FileHeadphone,
    "file-heart": FileHeart,
    "file-image": FileImage,
    "file-input": FileInput,
    "file-key": FileKey,
    "file-lock": FileLock,
    "file-minus": FileMinus,
    "file-minus-corner": FileMinusCorner,
    "file-music": FileMusic,
    "file-output": FileOutput,
    "file-pen": FilePen,
    "file-pen-line": FilePenLine,
    "file-play": FilePlay,
    "file-plus": FilePlus,
    "file-plus-corner": FilePlusCorner,
    "file-question-mark": FileQuestionMark,
    "file-scan": FileScan,
    "file-search": FileSearch,
    "file-search-corner": FileSearchCorner,
    "file-signal": FileSignal,
    "file-sliders": FileSliders,
    "file-spreadsheet": FileSpreadsheet,
    "file-stack": FileStack,
    "file-symlink": FileSymlink,
    "file-terminal": FileTerminal,
    "file-text": FileText,
    "file-type": FileType,
    "file-type-corner": FileTypeCorner,
    "file-up": FileUp,
    "file-user": FileUser,
    "file-video-camera": FileVideoCamera,
    "file-volume": FileVolume,
    "file-x": FileX,
    "file-x-corner": FileXCorner,
    files: Files,
    film: Film,
    "fingerprint-pattern": FingerprintPattern,
    "fire-extinguisher": FireExtinguisher,
};

export default shard;
